<!-- Visualizzazione cards -->
<section class="flex flex-col justify-center items-center bg-white w-full h-full text-center transition duration-300" *ngIf="card">    
    <img #img class="m-8 rounded-full w-60 h-60 aspect-square" [src]="(spettacolo?.img_box + '?type=spettacolo' | image)" (error)="img.classList.add('object-none', 'border', 'border-gray-300'); img.src= '../../../assets/images/logo.svg'" />
    <div class="flex flex-col justify-between gap-8 lg:gap-16 px-container py-8 w-full h-full testo">
        <div class="flex flex-col items-center gap-6 w-full">            
            <app-date-spettacolo [spettacolo]="spettacolo" colore="dark" class="lg:w-1/2 w-2/3"></app-date-spettacolo>            
            <div class="relative">
                <h1 class="font-bold text-2xl uppercase">{{spettacolo?.spettacolo}}</h1>
                <span class="inline-block font-mono text-base italic" [innerHTML]="spettacolo?.compagnia"></span>                
            </div>
        </div>
        <div class="flex lg:flex-row flex-col justify-center gap-4 buttons">
            <button class="btn btn-outln btn-sm scopri" (click)="onSpettacolo(spettacolo)">scopri</button>
            <app-button-spettacolo classi="block text-center btn btn-primary btn-sm" [spettacolo]="spettacolo" [calendario]="spettacolo?.calendario || []"></app-button-spettacolo>
        </div>
    </div>
</section>
<!-- Visualizzazione lista -->
<section class="flex lg:flex-row flex-col lg:justify-between lg:items-center lg:gap-16 gap-8 p-8 w-full item-list" *ngIf="!card">
    <div class="flex flex-col items-center gap-6 w-full lg:w-1/5">        
        <app-date-spettacolo [spettacolo]="spettacolo" colore="dark" class="w-1/2 lg:w-full self-start"></app-date-spettacolo>        
        <div class="w-full">
            <h1 class="font-bold text-2xl uppercase">{{spettacolo?.spettacolo}}</h1>
            <span class="font-mono text-base italic" [innerHTML]="spettacolo?.compagnia"></span>                
        </div>
    </div>
    <div class="flex lg:flex-row flex-col justify-end gap-4 buttons-list">
        <button class="grow-0 btn btn-outln btn-sm btn-discover" (click)="onSpettacolo(spettacolo)">scopri</button>
        <app-button-spettacolo classi="block text-center btn btn-primary btn-sm grow" [spettacolo]="spettacolo" [calendario]="spettacolo?.calendario || []" *ngIf="visible"></app-button-spettacolo>
    </div>
</section>